import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { AppStorage } from 'app/utilities/storage';

@Pipe({
    name: 'localDate',
    standalone: false
})
@Injectable({
	providedIn: 'root',
})
export class LocalDatePipe implements PipeTransform {

  transform(date: number | string | Date | undefined): string {
    if (!date) return '-';
    const locale = AppStorage.getLocalStorageDataRaw('X-User-Locale') || 'en-US';
    
    return new Date(date).toLocaleString(locale, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            });
  }
}
